module.exports = __webpack_public_path__ + "static/media/TH.df7db554.svg";